import { Routes } from '@angular/router';

export const pickupRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pickup.component').then((m) => m.PickupComponent),
  },
];
